import React, { useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import AuthProvider from '../guards/AuthProvider.js'
import axios from 'axios'
import logoutUtil from '../utils/logout.js'

function Logout() {
    const [auth, setAuth] = useContext(AuthProvider);
    let history = useHistory()

    useEffect(() => {
        const logout = logoutUtil.getParamFromCurrentUrl('logout')
        if (logout) {
            setAuth(null)
            axios.post(logoutUtil.getBaseUrl() + '/api/logout').then(res => {
                console.log('success logout')
                history.push('/login')
            }).catch(err => {
                console.log(err)
            })
        } else {
            window.location.href = logoutUtil.getLogoutUrl();
        }
    }, [])

    return (
        <div>
            
        </div>
    );
}

export default Logout;